export enum AssignmentDrawerMode {
  CREATE = 'create',
  EDIT = 'edit',
  COPY = 'copy',
}
